"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fill = exports.stroke = exports.bgColor = exports.hoverColor = exports.color = void 0;
const utils_1 = require("./utils");
const colors_1 = require("../colors");
const colors_m_scss_1 = __importDefault(require("./colors.m.scss"));
const isColorKey = colors_1.COLORS.has.bind(colors_1.COLORS);
/** @deprecated */
exports.color = (0, utils_1.ClassGetter)(colors_m_scss_1.default, isColorKey, 'color__');
/** @deprecated */
exports.hoverColor = (0, utils_1.ClassGetter)(colors_m_scss_1.default, isColorKey, 'hover-color__');
/** @deprecated */
exports.bgColor = (0, utils_1.ClassGetter)(colors_m_scss_1.default, isColorKey, 'bg-color__');
/** @deprecated */
exports.stroke = (0, utils_1.ClassGetter)(colors_m_scss_1.default, isColorKey, 'stroke__');
/** @deprecated */
exports.fill = (0, utils_1.ClassGetter)(colors_m_scss_1.default, isColorKey, 'fill__');
//# sourceMappingURL=colors.js.map